/**
* @license lucide-solid v0.354.0 - ISC
*
* This source code is licensed under the ISC license.
* See the LICENSE file in the root directory of this source tree.
*/

// src/icons/message-circle-more.tsx
import Icon from "../Icon";
var iconNode = [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }]
];
var MessageCircleMore = (props) => <Icon {...props} name="MessageCircleMore" iconNode={iconNode} />;
var message_circle_more_default = MessageCircleMore;
export {
  message_circle_more_default as default
};
//# sourceMappingURL=message-circle-more.jsx.map
